import React from 'react'
import { useAmp } from 'next/amp'

interface ConvertKitEdmProps {
  id: string
  isAmp?: boolean // 服務端傳入的 AMP 狀態
}

function ConvertKitEdm({ id, isAmp: serverSideIsAmp }: ConvertKitEdmProps) {
  // 優先使用 serverSideIsAmp, 備用 nextSideIsAmp
  // 這些 log 是用來看 AMP 判別在這些環節的變化: CSR SSR with Hydration
  const nextSideIsAmp = useAmp()
  const isAmp = serverSideIsAmp !== undefined ? serverSideIsAmp : nextSideIsAmp

  // 簡潔明瞭：AMP 頁面直接不渲染
  if (isAmp) {
    return (
      <div style={{ display: 'none' }}>
        {/* CONVERTKIT_HIDDEN_FOR_AMP */}
      </div>
    )
  } else {
    return (
      <>
        <div style={{ display: 'none' }}>
          {/* CONVERTKIT_HIDDEN_FOR_AMP */}
        </div>
        {/* DEBUG Info */}
        <div
          style={{ display: 'none' }}
          data-component="ConvertKitEd"
          data-debug="SERVER_SIDE_DETECTION"
          data-next-side-isamp={nextSideIsAmp ? 'TRUE' : 'FALSE'}
          data-server-side-isamp={serverSideIsAmp ? 'TRUE' : 'FALSE'}
          data-isamp={isAmp ? 'TRUE' : 'FALSE'}
          data-source={serverSideIsAmp !== undefined ? 'SERVER' : 'CLIENT'}
        >
        </div>
        {/* CONVERTKIT_RENDERED_FOR_NON_AMP */}
      </>
    )
  }
}

export default ConvertKitEdm
